/**
 * Belarusian ruble.
 */
export var BYN = {
  code: 'BYN',
  base: 10,
  exponent: 2
};